import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

class CtaV6 extends Component {
  render() {
    return (
      <section className="cta-nine  go-top">
        <div className="container-fluid">
          <div className="cta-nine__block">
            <h3>How We Work</h3>
            <p>
              Discover our seamless approach to digital marketing, business
              development, and consultancy, combining strategic insights to
              drive your business forward.
              <br /> From in-depth analysis to strategic planning and flawless
              execution, we work hand in hand with you to achieve measurable
              results and sustainable growth.
            </p>
          </div>
          {/* /.cta-nine__block */}
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="cta-nine__single">
                <div className="cta-nine__icon">
                  <i className="fal fa-user-alt" />
                  <h3>Analysis </h3>
                  <p>
                    We conduct thorough research and data analysis to understand
                    your business goals and target audience.
                  </p>
                </div>
                {/* /.cta-nine__icon */}
              </div>
              {/* /.cta-nine__single */}
            </div>
            {/* /.col-lg-3 col-md-6 */}
            <div className="col-lg-3 col-md-6">
              <div className="cta-nine__single">
                <div className="cta-nine__icon">
                  <i className="fal fa-cloud-download" />
                  <h3> Planning </h3>
                  <p>
                    Our experienced team develops tailored strategies and plans
                    to maximize your business growth and online presence.
                  </p>
                </div>
                {/* /.cta-nine__icon */}
              </div>
              {/* /.cta-nine__single */}
            </div>
            {/* /.col-lg-3 col-md-6 */}
            <div className="col-lg-3 col-md-6">
              <div className="cta-nine__single">
                <div className="cta-nine__icon">
                  <i className="fal fa-chart-line" />
                  <h3>Implementation </h3>
                  <p>
                    We execute the planned strategies, leveraging cutting-edge
                    tools and techniques to drive results and exceed your
                    expectations.
                  </p>
                </div>
                {/* /.cta-nine__icon */}
              </div>
              {/* /.cta-nine__single */}
            </div>
            {/* /.col-lg-3 col-md-6 */}
            <div className="col-lg-3 col-md-6">
              <div className="cta-nine__single">
                <div className="cta-nine__icon">
                  <i className="fal fa-gift-card" />
                  <h3>Enhancement</h3>
                  <p>
                    We continuously monitor and optimize your campaigns,
                    providing ongoing support and refining strategies for
                    long-term success.
                  </p>
                </div>
                {/* /.cta-nine__icon */}
              </div>
              {/* /.cta-nine__single */}
            </div>
            {/* /.col-lg-3 col-md-6 */}
          </div>
          {/* /.row */}
        </div>
        {/* /.container-fluid */}
      </section>
    );
  }
}

export default CtaV6;
